import { render } from "./pekerjaan-list-remote.vue?vue&type=template&id=c608d054"
import script from "./pekerjaan-list-remote.vue?vue&type=script&lang=js"
export * from "./pekerjaan-list-remote.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__